module.exports = __webpack_public_path__ + "img/Mitos y Leyendas.ba4949c1.svg";